import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stx',
  templateUrl: './stx.component.html',
  styleUrls: ['./stx.component.scss']
})
export class StxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
